module.exports = __webpack_public_path__ + "components/flag/static/square/gb-75ddc5e71bffab303ea577158b738a73.svg";